<template>
  <div class="productWrapper">
    <van-card
      v-for="(item, index) in productList"
      :key="item.id || item.productId"
      :desc="formatDesc(item)"
      :price="formatePrice(item)"
      :title="item.name || item.productName"
      @click="toDetail(item.id || item.productId)"
      :thumb="
        item.picture || 'https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg'
      "
    >
      <template #footer v-if="type !== 'search'">
        <van-button
          size="normal"
          @click="modifyProduct(item)"
          class="fs14"
          v-if="type === 'edit'"
          >编辑</van-button
        >
        <div v-else-if="type.includes('purchase')" class="cart" @click.stop="">
          <div v-if="item[numKey]" class="numChangeBox" @click.stop="">
            <van-icon
              class="circleIcon"
              name="minus"
              @click="minus($event, item, index)"
            />
            <van-field
              class="numInput"
              autocomplete="off"
              type="number"
              v-model="item[numKey]"
              @change="inputChange($event, item, index)"
            >
            </van-field>
            <van-icon
              class="circleIcon"
              name="plus"
              @click="plus($event, item, index)"
            />
          </div>
          <van-icon
            v-else
            name="shopping-cart-o"
            size="20"
            color="#4c9673"
            @click="plus($event, item, index)"
          />
        </div>
      </template>
    </van-card>
  </div>
</template>

<script>
import { Button } from "vant";
import moment from "moment";

export default {
  name: "ProductItem",
  components: {
    vanButton: Button,
  },
  props: {
    products: Array,
  },
  computed: {
    productList() {
      return this.products.map((el, i) => {
        const item = { ...el };
        const index = this.ordering?.tableData?.findIndex((t) => {
          return t.productId === item.productId;
        });
        if (index > -1) {
          item[this.numKey] = this.ordering?.tableData[index][this.numKey];
        }

        return item;
      });
    },
  },
  data() {
    return {
      ordering: { tableData: [] },
      loading: false,
      productsBySort: [],
      showPicker: false,
      formData: {
        updatePrice: 0,
      },
      name: "",
      type: "edit",
      numKey: "purchaseNum",
      storageOrdering: {},
    };
  },
  watch: {
    ordering: {
      handler(newVal) {
        if (newVal && newVal.scId) {
          localStorage.setItem(this.orderingKey, JSON.stringify(newVal));
        }
      },
      deep: true,
    },
  },
  beforeRouteLeave(to, from, next) {
    
    next();
  },
  created() {},
  mounted() {
    const params = this.$route.query;
    this.type = params.type ?? "edit";
    this.orderingKey = this.type + "ing";
    if (this.type === "purchaseOrder") {
      this.numKey = "purchaseNum";
    } else if (this.type === "purchaseReturn") {
      this.numKey = "returnNum";
    } else if (this.type === "purchaseReceive") {
      this.numKey = "receiveNum";
    }
    this.storageOrdering = JSON.parse(
      localStorage.getItem(this.orderingKey) || "{}"
    );
    this.ordering = JSON.parse(localStorage.getItem(this.orderingKey) || "{}");
    const queryForm = JSON.parse(localStorage.getItem("queryForm") || "{}");
    this.ordering = Object.assign({ tableData: [] }, this.ordering, queryForm);
  },
  methods: {
    formatDesc(item) {
      return "商品条码：" + item.externalCode;
    },
    handleQuantityUpdate(item, index, newValue) {
      debugger;
      newValue = Math.max(Number(newValue) || 0, 0);
      const productId = item.productId;
      const dataIndex = this.ordering.tableData.findIndex(
        (t) => t.productId === productId
      );
      if (dataIndex > -1) {
        
        newValue > 0
          ? this.$set(this.ordering.tableData[dataIndex], this.numKey, newValue)
          : this.ordering.tableData.splice(dataIndex, 1);
        
      } else if (newValue > 0) {
        this.ordering.tableData.push(this.createOrderItem(item, newValue));
      }
    },

    createOrderItem(item, quantity) {
      return {
        ...item,
        [this.numKey]: quantity,
        description: "",
        productionDate: "",
        shelfLifeDays: "0",
        shelfLife: "",
      };
    },
    inputChange(event, item, index) {
      event.stopPropagation();
      this.handleQuantityUpdate(item, index, event.target.value);
    },
    minus(event, item, index) {
      event.stopPropagation();
      const current = Number(item[this.numKey] || 0);
      const newValue = this.$utils.preciseSubtraction(current, 1);
      this.handleQuantityUpdate(item, index, newValue);
    },
    plus(event, item, index) {
      event.stopPropagation();
      const current = Number(item[this.numKey] || 0);
      const newValue = this.$utils.preciseAdd(current, 1);
      this.handleQuantityUpdate(item, index, newValue);
    },
    formatePrice(item) {
      const unit = item.unit ? "/" + item.unit : "";
      if (this.type.includes("purchase")) {
        return String(item.purchasePrice).includes(".")
          ? item.purchasePrice + unit
          : item.purchasePrice + ".00" + unit;
      } else {
        return String(item.retailPrice).includes(".")
          ? item.retailPrice + unit
          : item.retailPrice + ".00" + unit;
      }
    },
    modifyProduct(row) {
      console.log(row,'modifyProduct');
      this.$router.push("/product/modify/" + row.id || row.productId);
    },
    toDetail(id) {
      if (this.type === "edit") {
        return;
      }
      localStorage.setItem(
        "productDetail-preRoute",
        JSON.stringify({
          path: "/product/category",
          query: {type:`${this.type}`},
        })
      );
      this.$router.push({ path: "/productDetail/" + id });
    },
    addDays(date, days) {
      if (!date || !days) {
        return "";
      }
      const result = new Date(date);
      result.setDate(result.getDate() + Number(days));
      return moment(result).format("YYYY-MM-DD");
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
::v-deep .van-card__title {
  font-size: 17px;
  height: 50px;
  padding: 10px 0;
}
.cart {
  height: 35px;
}
.numChangeBox {
  width: 150px;
  float: right;
  background: #fafafa;
  align-items: center;
  .numInput {
    font-weight: 600;
    color: #000;
    width: 100px;
    padding: 2px 0 0 10px;
  }
}
</style>
